import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["containerClassName", "count", "dateTransform", "dateType", "end", "hover", "offset", "start", "step", "tile", "value", "valueType", "keyboardNavDate", "selectRange", "activeStartDate"];
import React, { useContext } from 'react';
import CalendarPickerContext from '../../context/CalendarPickerContext';
var TileGroup = function TileGroup(_ref) {
  var containerClassName = _ref.containerClassName,
    _ref$count = _ref.count,
    count = _ref$count === void 0 ? 3 : _ref$count,
    dateTransform = _ref.dateTransform,
    dateType = _ref.dateType,
    end = _ref.end,
    hover = _ref.hover,
    offset = _ref.offset,
    start = _ref.start,
    _ref$step = _ref.step,
    step = _ref$step === void 0 ? 1 : _ref$step,
    Tile = _ref.tile,
    value = _ref.value,
    valueType = _ref.valueType,
    keyboardNavDate = _ref.keyboardNavDate,
    selectRange = _ref.selectRange,
    activeStartDate = _ref.activeStartDate,
    tileProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var tiles = [];
  var _useContext = useContext(CalendarPickerContext),
    dateValidator = _useContext.dateValidator,
    minDate = _useContext.minDate,
    maxDate = _useContext.maxDate,
    maxDetail = _useContext.maxDetail,
    disabledDays = _useContext.disabledDays,
    disabledDates = _useContext.disabledDates,
    disabledRanges = _useContext.disabledRanges,
    mergedDisabledDatesIntervals = _useContext.mergedDisabledDatesIntervals,
    dateCalculator = _useContext.dateCalculator,
    momentUtils = _useContext.momentUtils;
  var isSameDates = dateValidator.isSameDates;
  var daysInMonth = momentUtils.daysInMonth;
  for (var point = start; point <= end; point += step) {
    var date = dateTransform(point);
    var startDate = dateTransform(start);
    var endDate = dateTransform(end);
    var midDate = dateTransform(start + 6);
    var tilesInView = daysInMonth(midDate);
    var isFocusable = isSameDates(date, keyboardNavDate, dateType);
    var isNeighboringDate = maxDetail === 'month' && (point <= 0 || point > tilesInView);
    var tileClassName = dateCalculator.calculateTileClasses({
      selectRange: selectRange,
      value: value,
      valueType: valueType,
      date: date,
      dateType: dateType,
      hover: hover,
      keyboardNavDate: keyboardNavDate,
      startDate: startDate,
      endDate: endDate,
      isNeighboringDate: isNeighboringDate
    });
    tiles.push( /*#__PURE__*/React.createElement(Tile, _extends({
      classes: tileClassName,
      value: value,
      date: date,
      point: point,
      key: point,
      tabIndex: isFocusable ? 0 : -1,
      dateValidator: dateValidator,
      minDate: minDate,
      maxDate: maxDate,
      maxDetail: maxDetail,
      disabledDays: disabledDays,
      disabledDates: disabledDates,
      disabledRanges: disabledRanges,
      mergedDisabledDatesIntervals: mergedDisabledDatesIntervals
    }, tileProps)));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: containerClassName
  }, tiles);
};
export default TileGroup;